import { getAxiosErrorMessage } from '~/helpers/axios-error'

export default (context, inject) => {
  const handler = {
    handle: ({ error }) => {
      // axios のエラーレスポンスの文言(トークンが一時的に取れずに 401 になった場合は通信失敗の文言)
      const errorMessage =
        getAxiosErrorMessage(error) || '予期せぬエラーが発生しました'

      context.error({
        statusCode: 400,
        message: errorMessage
      })
    },
    isRequireCertificate: ({ error }) => {
      return error.response?.data?.error_code === 'required_certificate'
    },
    isRequireIndividualInformation: ({ error }) => {
      return (
        error.response?.data?.error_code === 'required_individual_information'
      )
    }
  }

  context.$error = handler
  inject('error', handler)
}
